import * as React from "react";
import {
  AdvancedSearchEvent,
  BooleanSearchForm,
} from "../../BooleanSearchForm";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isAdvancedSearchTerm } from "./advanced/AdvancedSearchTerm";
import { advancedSearchTermAdapter } from "./advanced/advancedSearchTermAdapter";

export const BooleanSearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { locationConfiguration: { pacSettings } = { pacSettings: null } } =
    useLocationConfiguration();
  const navigate = useNavigate();

  const handleAdvancedSearchEvent = (event: AdvancedSearchEvent) => {
    const { searchString, branchFilters } = event;
    if (!isAdvancedSearchTerm(searchString)) return;

    const params = new URLSearchParams(searchParams);
    if (Array.isArray(branchFilters)) {
      params.set("branchFilters", JSON.stringify(branchFilters));
    }
    navigate(
      `/advanced-search/boolean/results?${advancedSearchTermAdapter
        .setTerm(params, searchString)
        .toString()}`
    );
  };

  return (
    <BooleanSearchForm
      allowTagging={pacSettings?.userActionSettings?.allowTagging}
      onClickSearch={handleAdvancedSearchEvent}
    ></BooleanSearchForm>
  );
};
